// SPDX-License-Identifier: AGPL-3.0-or-later
import { daysInMonth, isoDate, weekday } from "./dates.js";
/**
 * Lays out a month as a 7-column week grid, one cell per day, carrying the
 * day's value (for example net cash flow). This is the data behind both the
 * isometric 3D calendar and its accessible 2D fallback.
 */
export function calendarMonth(year, month, valueFor) {
    const first = isoDate(year, month, 1);
    const offset = weekday(first);
    const days = daysInMonth(year, month);
    const cells = [];
    for (let day = 1; day <= days; day++) {
        const date = isoDate(year, month, day);
        const index = offset + day - 1;
        cells.push({ date, month, column: index % 7, row: Math.floor(index / 7), value: valueFor(date) });
    }
    const rows = Math.ceil((offset + days) / 7);
    return { year, month, rows, cells };
}
export function calendarYear(year, valueFor) {
    return Array.from({ length: 12 }, (_, i) => calendarMonth(year, i + 1, valueFor));
}
/** Sums signed amounts per day. */
export function dailyTotals(items) {
    const totals = new Map();
    for (const { date, amount } of items)
        totals.set(date, (totals.get(date) ?? 0) + amount);
    return totals;
}
/**
 * The bar-height cap for the calendar: a high percentile of absolute daily
 * values, so one rent day does not flatten every other bar.
 */
export function barCap(values, percentile = 0.95) {
    const abs = values.map((v) => Math.abs(v)).filter((v) => v > 0).sort((a, b) => a - b);
    if (abs.length === 0)
        return 1;
    const index = Math.min(abs.length - 1, Math.floor(percentile * (abs.length - 1)));
    return Math.max(1, abs[index] ?? 1);
}
//# sourceMappingURL=calendar.js.map